import React, {Component} from 'react'
import * as colors from '../colors'
import {style, media, merge} from 'glamor'

export default class Image extends Component {

  render(){
    return (
      <img
        {...this.props}
        {...style({
          display: 'block',
          width: '100%'
        })}
      />
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Image.js
 **/